// © Microsoft Corporation. All rights reserved.

import { TelemetryBehaviorType, TelemetryContentType, TelemetryObjectBase } from "@msnews/telemetry-contracts";

import { genericTelemetryClickDispatcher, getPageContentType } from "@msnews/social-utils";

export interface CommentItemTelemetryObjects {
    commentItem: TelemetryObjectBase; // from contract: commentItem / deletedCommentItem / reportedCommentItem
    reportButton: TelemetryObjectBase;
    deleteButton: TelemetryObjectBase;
    reactionsCount: TelemetryObjectBase;
    reactionBreakdown: TelemetryObjectBase;
    userNameLink: TelemetryObjectBase;
    userAvatarLink: TelemetryObjectBase;
    mentionUserLink: TelemetryObjectBase;
    deletedMessage: TelemetryObjectBase;
}

export const commentItemTelemetryContracts = {
    commentItem: {
        name: "Comment",
        content: { type: TelemetryContentType.Comment }
    },
    deletedCommentItem: {
        name: "CommentDeletedModerator",
        content: { type: TelemetryContentType.Comment }
    },
    reportedCommentItem: {
        name: "CommentReported",
        content: { type: TelemetryContentType.Comment }
    },
    reactionBreakdown: {
        content: { type: TelemetryContentType.Comment }
    },
    reportButton: { // Comments-Scenario 10a click
        name: "Report",
        behavior: TelemetryBehaviorType.Report,
        content: {
            headline: "Report",
            type: TelemetryContentType.Comment
        }
    },
    deleteButton: { // Scenario 10b click
        name: "Delete",
        behavior: TelemetryBehaviorType.Remove,
        content: {
            type: TelemetryContentType.Comment,
            headline: "Delete"
        }
    },
    reactionsCount: { // CommentReactions>Scenario 1
        name: "CommentReactions",
        behavior: TelemetryBehaviorType.Open,
        content: {
            type: TelemetryContentType.Comment,
            headline: "Reactions"
        }
    },
    profileLink: {
        name: "Profile",
        behavior: TelemetryBehaviorType.Navigate,
        content: {
            type: TelemetryContentType.Profile
        }
    },
    guidelinesLink: {
        name: "CommunityGuidelines",
        behavior: TelemetryBehaviorType.Navigate,
        content: {
            type: getPageContentType(),
            headline: "CommunityGuidelines"
        }
    }
};

export const commentItemTelemetryActionDispatchers = {
    genericClick: genericTelemetryClickDispatcher
};